import BreadcrumbsSchema from "./BreadcrumbsSchema";

export default BreadcrumbsSchema;
